import styled, { css } from "styled-components";
import FavoriteIcon from "@assets/icons/circle_favorite.svg";
import { Colors } from "shared/styles";
import { useBreadcrumb } from "features/shared/hooks/useBreadcrumb";
import { Paths } from "utils/routes";
import { Image } from "shared/components/atoms/Image";
import { useFavorite } from "features/shared/hooks/useFavorite";
import { Breadcrumb } from "components/atoms/Breadcrumb";
import { IconButton } from "shared/components/atoms/IconButton";
import { useMenuContext } from "../hooks/useMenuContext";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import tw from "twin.macro";
import { useCampaign } from "features/shared/hooks/useCampaign";

const favoritedCss = css({
  circle: {
    color: Colors.pink["01"],
  },
  path: {
    color: "#fff",
  },
});

const FavoriteButton = styled(IconButton)`
  circle {
    color: ${Colors.blue["01"]};
  }
  path {
    color: ${Colors.pink["01"]};
  }
  color: #fff;
  position: absolute;
  bottom: -32px;
  right: 24px;
`;

const TimeCard = tw.span`bg-[#FE4FD0] p-1 rounded text-white mx-1`;

const ms = 1000;
const hour = 60 * 60;

export const MenuBannerImage = () => {
  const [now, setNow] = useState(dayjs());
  const { menu, mutate } = useMenuContext();

  const isChatMenu = menu?.type === "chat";
  const nextMenu = {
    [isChatMenu ? "fortune" : "telFortune"]: {
      ...menu,
      isFavorited: !menu?.isFavorited,
    },
  };

  const { onClickFavorite, disabled } = useFavorite(() =>
    mutate(nextMenu as any)
  );

  const { showCampaignPromotion, coupon } = useCampaign({
    fortuneTellerId: menu?.fortuneTeller?.id,
  });

  const detailPagePath = isChatMenu
    ? Paths.fortunes.show(menu?.id)
    : Paths.telFortunes.show(menu?.id);

  const breadCrumbItems = useBreadcrumb([
    { name: menu?.category.name, item: `/categories/${menu?.category.alias}` },
    {
      name: menu?.title,
      item: detailPagePath,
    },
  ]);

  const handleClickFavorite = () => {
    onClickFavorite(menu);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(dayjs());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  console.log(coupon);

  const diff = showCampaignPromotion
    ? dayjs(coupon?.expiredAt).diff(now)
    : undefined;
  const diffSec = showCampaignPromotion ? diff / ms : undefined;
  const days = showCampaignPromotion
    ? Math.floor(diffSec / (hour * 24))
    : undefined;
  const hours = showCampaignPromotion
    ? Math.floor(diffSec / hour - 24 * days)
    : undefined;
  const minutes = showCampaignPromotion
    ? Math.floor(diffSec / 60 - 60 * hours - 60 * 24 * days)
    : undefined;
  const seconds = showCampaignPromotion
    ? Math.floor(diffSec - hour * 24 * days - hour * hours - 60 * minutes)
    : undefined;

  return (
    <div tw="relative">
      <Image
        src={menu?.imageUrl}
        layout="dynamic"
        objectFit="cover"
        tw="w-full h-[220px]"
      />
      <div tw="absolute top-0 w-full h-[220px] flex bg-gradient-to-b from-[rgba(0,0,0,0.4)] to-[rgba(0,0,0,0) 40%]">
        <Breadcrumb itemListElements={breadCrumbItems} transparent />
        <div tw="absolute w-full top-0">
          {showCampaignPromotion && (
            <div tw="bg-[#FFDDF7] rounded-full text-[11px] p-2 w-11/12 mx-auto mt-3 text-center">
              <span tw="leading-[.45px] text-black top-8">
                クーポン利用期限まで
              </span>
              <TimeCard>{days}</TimeCard>日<TimeCard>{hours}</TimeCard>時間
              <TimeCard>{minutes}</TimeCard>分<TimeCard>{seconds}</TimeCard>秒
            </div>
          )}
        </div>
        <FavoriteButton
          icon={
            <FavoriteIcon
              width={72}
              height={72}
              viewBox="0, 0, 96, 96"
              tw="svg"
              css={menu?.isFavorited && favoritedCss}
            />
          }
          onClick={handleClickFavorite}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
